<template lang="pug">
.login-email-password 
    v-label.login-email-password--heading(v-if="!errorOnLogin") Allons-y ! 🙌
    v-label.login-email-password--heading(v-if="errorOnLogin") Ah ! 😮
    .login-email-password--error(v-if="errorOnLogin") 
      .info(v-if="errorOnLogin") Il y a un problème lié à votre connexion. Veuillez contacter votre référent Epoca afin qu’il puisse vous aider. 
      .login-email-password--goback-container(v-if="errorOnLogin")
        v-btn.login-email-password--goback-btn(variant="text" @click="goToLogin")
          v-label.login-email-password--goback-btn__label Revenir à la page de connexion
    v-form(ref="loginForm" @submit="validate" v-if='!credentialSent && !errorOnLogin && !fASent && !isRenewPassword && !otpSent && !pscCibaCode')
        div.input-container
          div(v-if="!isRememberMeAvailable || selectedRememberedUser")
            .login-email-password--input-container(v-if="!selectedRememberedUser")
              v-text-field(
                elevation="0"
                v-model='emailOrRpps'
                :rules="[isRequired]"
                label='Email ou Identifiant RPPS'
                name='email'
                variant="outlined"
                :error="emailError.isValid === false"
                :error-messages="emailError.message"
                density="compact"
                single-line
                @update:modelValue='checkIfEmailOrMobile'
              )
              .login-email-password--input-container__icon
                v-icon epoca:loginUser
            div.user-list(v-if="selectedRememberedUser" :style="{ paddingRight: '0px' }")
              div.user-item
                div.avatar
                  span.initials {{ selectedRememberedUser.initials }}

                div.text-block
                  div.name {{ selectedRememberedUser.name }}
                  div.email(v-if="selectedRememberedUser.type === 'email'") {{ selectedRememberedUser.email }}

                div.append-icons
                  v-menu(bottom class="append-icons-menu")
                    template(#activator="{ props }")
                      v-btn(icon variant="text" v-bind="props" @click.stop)
                        v-icon(size="16") mdi-dots-vertical
                    v-list
                      v-list-item(@click.stop="removeRememberedUser(selectedRememberedUser)")
                        v-icon(v-bind="props") epoca:linkIcon
                        v-list-item-title Oublier ce compte
            .login-email-password--input-container(data-type="password" v-if="isEmailAuthent")
              v-text-field(
                elevation="0"
                v-model="password"
                :rules="[isRequired]"
                variant="outlined"
                name='password'
                density="compact"
                :error="passwordError.isValid === false"
                :error-messages="passwordError.message"
                :type="showPassword ? 'text' : 'password'"
                label="Mot de passe"
                single-line
                @update:modelValue='()=>{passwordError.isValid = true; passwordError.message = ""}'
                @click:append="showPassword = !showPassword"
              )
              .login-email-password--input-container__password-icon(@click="showPassword = !showPassword")
                v-icon(v-if="showPassword") mdi-eye-outline
                v-icon(v-else) mdi-eye-off-outline
              .login-email-password--input-container__icon
                v-icon epoca:loginLock
          div.user-list(v-if="isRememberMeAvailable && !selectedRememberedUser" :style="{ paddingRight: scrollPadding + 'px' }")
            div.user-item(
              v-for="user in rememberedUsersArray"
              :key="user.id"
              @click="selectUser(user)"
            )
              div.avatar
                span.initials {{ user.initials }}

              div.text-block
                div.name {{ user.name }}
                div.email(v-if="user.type === 'email'") {{ user.email }}
                div.email(v-else) {{ user.type === 'RPPS' ? 'RPPS' : 'Téléphone' }}

              div.append-icons
                v-menu(bottom class="append-icons-menu")
                  template(#activator="{ props }")
                    v-btn(icon variant="text" v-bind="props" @click.stop)
                      v-icon(size="16") mdi-dots-vertical
                  v-list
                    v-list-item(@click.stop="removeRememberedUser(user)")
                      v-icon(v-bind="props") epoca:linkIcon
                      v-list-item-title Oublier ce compte
                v-icon(size="20") mdi-chevron-right
          .login-email-password--remember-modify-password
            .checkbox-with-info-icon(v-if="!isRememberMeAvailable")
              v-checkbox(
                v-model="rememberMe"
                density="compact"
                hide-details
                color="primary"
                @update:modelValue="clickRememberMe"
              )
                template(#label)
                  .login-email-password--password-reset__label Se souvenir de moi
              .icon-container
                v-tooltip(open-on-click text="Nous mémorisons vos informations de compte pour votre prochaine connexion" location="bottom" class="custom-tooltip")
                  template(#activator="{ props }")
                    v-icon(v-bind="props") epoca:info
            v-btn(v-if="isRememberMeAvailable").login-email-password--password-reset(variant="text" @click="useAnotherAccount")
              v-label.login-email-password--password-reset__label Utiliser un autre compte
            v-btn(v-if="isEmailAuthent || (selectedRememberedUser && selectedRememberedUser.type === 'email')").login-email-password--password-reset(variant="text" @click="resetPassword")
              v-label.login-email-password--password-reset__label Mot de passe oublié ?
        #recaptcha(v-show='!otpSent && (isEmailAuthent || (isPhone(emailOrRpps) && systemSettings?.data?.is_mobile_login)) && (!isRememberMeAvailable || (selectedRememberedUser && ["email", "phone"].includes(selectedRememberedUser.type)))')
        v-btn(v-if="selectedRememberedUser || !isRememberMeAvailable").login-email-password--button(variant="text" :disabled="emailLoginInProgress" @click="onEmailSubmit")
            v-icon(right) epoca:loginKey
            v-label.login-email-password--button__label S'IDENTIFIER
            v-progress-circular(v-if="emailLoginInProgress" indeterminate size="16" :width="2")

    v-form(v-if='otpSent||fASent' ref="otpForm")
        .info(v-if="info.length") {{info}}
          .info--contact(v-if="!isOTPVerified") 01 79 35 07 14
        div(v-if="isOTPVerified")
          .login-otp--input-container
            v-otp-input(
              length=6
              :error="otpInError"
              type='number'
              v-model='otp'
              :rules="[isRequired, isOTP]"
              @update:modelValue='()=>{otpError = false; otpInError = false;}'
            )
          .login-otp--input-container__error-message(v-if="otpInError")
            .otp-message Veuillez saisir le code de vérification reçu par SMS
        v-btn.login-email-password--button(variant="text" v-if="isOTPVerified" :disabled="otpVerificationInProgress" @click="validateOTP")
            v-icon(right) epoca:loginKey
            v-label.login-email-password--button__label Se connecter
            v-progress-circular(v-if="otpVerificationInProgress" indeterminate size="16" :width="2")
        .login-email-password--goback-container(v-if="!isOTPVerified || errorOnLogin")
          v-btn.login-email-password--goback-btn(variant="text" @click="goToLogin")
            v-label.login-email-password--goback-btn__label Revenir à la page de connexion
    .psc-ciba-code(v-if="pscCibaCode")
      v-label.heading Votre code d’authentification
      v-label.code {{pscCibaCode}}
    //- v-form(ref="renewPasswordForm" @submit="renewPassword" v-if='isRenewPassword')
    //-     v-label.mb-4 Votre mot de passe a expiré et doit être renouvelé 
    //-     v-text-field(
    //-         v-model="newPassword"
    //-         :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
    //-         :rules="[isRequired]"
    //-             variant="outlined"
    //-         :type="showPassword ? 'text' : 'password'"
    //-         label="Nouveau mot de passe"
    //-         @click:append="showPassword = !showPassword"
    //-     )
    //-     v-btn.mt-5(v-if='isRenewPassword' color="primary" @click="validateNewPassword" ) Renouveler le mot de passe
    //-     v-icon(right) mdi-cellphone-key
</template>

<script setup lang="ts">
import { OAuthProvider, getAuth, signInWithCredential } from 'firebase/auth'
const emailOrRpps = ref('')
const password = ref('')
const otp = ref('')
const credentialSent = ref(false)
const mfa = ref('')
const fASent = ref(false)
const otpError = ref(false)
const otpInError = ref(false)
const isRenewPassword = ref(false)
const showPassword = ref(false)
const isEmailAuthent = ref(false)
const loginForm: any = ref(null)
const otpForm: any = ref(null)
const info = ref('')
const otpSent = ref(false)
const showPasswordInput = ref(false)
const recaptchaSuccess = ref(false)
const pscCibaCode = ref<string>('')
const isApplyRecaptcha = ref(null)
const rememberMe = ref(true)
const isOTPVerified = ref(true)
const otpVerificationInProgress = ref(false)
const emailLoginInProgress = ref(false)
const errorOnLogin = ref(false)
const emailError = ref({
  isValid: true,
  message: '',
})

const passwordError = ref({
  isValid: true,
  message: '',
})

const systemSettings = ref<any>(null)
const isRememberMeAvailable = ref(false)
const rememberedUsersArray = ref<any[]>([])
const selectedRememberedUser = ref<any>(null)
const scrollPadding = ref(0)
const { sendEmailAndPassword, sendSMSCode, sentResetPasswordLink, applyRecaptcha, multiFactorWithSMS, sendPhoneNumber } =
  useAuth()

const isLoginProgress = computed(() => {
  return userStore.isLoginProgress
})
const rpps = ref('')
const userStore = useUserStore()
const emit = defineEmits(['on:show-psc'])
const checkOTP = (t: any) => {
  otpError.value = t.toString().length !== 6
}

const checkIfEmailOrMobile = async (e: string) => {
  emailError.value.isValid = true
  emailError.value.message = ''
  passwordError.value.isValid = true
  passwordError.value.message = ''
  if (info.value.length) info.value = ''
  if (isEmail(e)) {
    isEmailAuthent.value = true
    // if (!isApplyRecaptcha.value) {
    //   isApplyRecaptcha.value = true
    //   await applyRecaptcha()
    // }
  } else if (isPhone(e) && isEmailAuthent.value == true) {
    isEmailAuthent.value = false
  } else {
    isEmailAuthent.value = false
  }
}

const { $toast: toast, $api: api } = useNuxtApp()
const isRequired = (v: string) => v?.length > 0 || 'Ce champ est obligatoire'

const isPhone = (v: string) => {
  return (
    v === null ||
    (v.length === 10 && v.charAt(0) === '0' && (v.charAt(1) === '6' || v.charAt(1) === '7')) ||
    (v.length === 12 && (v.charAt(4) === '6' || v.charAt(4) === '7'))
  )
}

const isEmail = (v: string) => {
  return /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
    v,
  )
}

const isEmailOrMobile = (v: string) => {
  return isEmail(v) || isPhone(v) || "Le format n'est pas valide"
}

const validateNewPassword = () => {
  password.value = ''
  toast.success('Le mot de passe a été changé avec succès', {
    timeout: 5000,
  })
  isRenewPassword.value = false
}

const useAnotherAccount = () => {
  isRememberMeAvailable.value = false
  selectedRememberedUser.value = null
  emailOrRpps.value = ''
  password.value = ''
  emit('on:show-psc', true)
}

const getInitials = (name: string): string => {
  if (!name) return ''

  const words = name.trim().split(/\s+/)
  const first = words[0]?.[0] || ''
  const last = words[words.length - 1]?.[0] || ''

  return (first + last).toUpperCase()
}

const selectUser = (user: any) => {
  selectedRememberedUser.value = user
  emailOrRpps.value = user.email
  checkIfEmailOrMobile(user.email)
  if (user.type === 'RPPS') {
    emit('on:show-psc', true)
    emailLoginInProgress.value = true
    doLoginPscCiba()
  }
}

const clickRememberMe = (value) => {
  rememberMe.value = value
  localStorage.setItem('rememberMe', rememberMe.value.toString())
}

const resetPassword = () => {
  let navigateURL = `/forget-password`
  if (isEmail(emailOrRpps.value)) {
    navigateURL += `?email=${encodeURIComponent(emailOrRpps.value)}`
  }

  navigateTo(navigateURL)
}

const isOTP = (v: string) => {
  return v.length === 6 || 'Le format est incorrect'
}

const doSignInWithEmailAndPassword = async () => {
  credentialSent.value = true
}

const sendOTP = async (hint: string | null) => {
  fASent.value = true
  info.value = `Veuillez indiquer le code de vérification envoyé au ${hint}`
}

const doLoginEmailPassword = async () => {
  try {
    if (emailOrRpps.value === '' || password.value === '') {
      return
    }
    const log = await sendEmailAndPassword(emailOrRpps.value, password.value, window.recaptchaVerifier)

    if (log?.isSuccess) {
      if (log?.status === 'OTP_SENT') {
        sendOTP(log.hint)
        emailLoginInProgress.value = false
        return
      }
    } else {
      emailLoginInProgress.value = false
      errorOnLogin.value = true
      return
    }

    emailLoginInProgress.value = false

    if (log.status === 'OTP_ERROR') {
      info.value =
        'Il y a un problème lié à votre connexion. Veuillez contacter votre référent Epoca afin qu’il puisse vous aider.'
    }
    passwordError.value.isValid = false
    passwordError.value.message = 'Identifiant ou mot de passe invalide(s)'
  } catch (error) {
    console.error('Login error:', error)
  }
}
const getPhoneHint = (phone: string | null | undefined) => {
  if (!phone) return ''
  const str = String(phone).trim()
  const digits = str.replace(/\D/g, '')
  const last4 = digits.slice(-4)
  return `+*******${last4}`
}
const doLoginPhone = async () => {
  await sendPhoneNumber(window.recaptchaVerifier, emailOrRpps.value)
    .then((data) => {
      if (!data) {
        emailLoginInProgress.value = false
        return
      }
      emailLoginInProgress.value = false
      if (
        data &&
        data.code &&
        (data.code === 'auth/invalid-phone-number' || data.code === 'auth/admin-restricted-operation')
      ) {
        info.value = "Ce numéro de téléphone n'est pas reconnu, veuillez essayer un autre mode de connexion"
      } else {
        sendOTP(getPhoneHint(emailOrRpps.value))
        otpSent.value = true
      }
    })
    .catch((error: any) => {
      emailLoginInProgress.value = false
      console.log(error)
    })
}

const sendSMSCodeTo = async () => {
  let success = await sendSMSCode(otp.value)
}

const onEmailSubmit = async () => {
  await validate()
  return
}

const doLoginPscCiba = async () => {
  const { valid, errors } = await loginForm.value?.validate()
  if (valid) {
    userStore.isLoginProgress = true
    await api.auth
      .initiateCIBA(emailOrRpps.value)
      .then((crendentials) => {
        emailLoginInProgress.value = false
        pscCibaCode.value = crendentials.code
        window.setTimeout(getToken, 5100)
      })
      .catch((error: any) => {
        emailLoginInProgress.value = false
        userStore.isLoginProgress = false
        emailError.value.isValid = false
        emailError.value.message = 'Format invalide'
      })
  } else {
    emailLoginInProgress.value = false
  }
}

const goToLogin = async () => {
  errorOnLogin.value = false
  isOTPVerified.value = false
  selectedRememberedUser.value = null
  emailOrRpps.value = ''
  password.value = ''
  window.location.reload()
}

function removeRememberedUser(user) {
  const rememberedUsers = JSON.parse(localStorage.getItem('rememberUser') || '[]')
  const updatedUsers = rememberedUsers.filter((u) => u.id !== user.id)
  localStorage.setItem('rememberUser', JSON.stringify(updatedUsers))
  rememberedUsersArray.value = rememberedUsersArray.value.filter((u) => u.id !== user.id)
  selectedRememberedUser.value = null
  isRememberMeAvailable.value = updatedUsers.length > 0
}

function getToken() {
  api.auth
    .getCIBACredentials()
    .then((credentitals) => {
      if (!credentitals) window.setTimeout(getToken, 5100)
      const { idToken } = credentitals

      const provider = new OAuthProvider('oidc.psc')
      const credentials = provider.credential({
        idToken: idToken, // idtoken retourné par le back après le GET ciba
      })
      signInWithCredential(getAuth(), credentials)
        .then((result) => {
          const credential = OAuthProvider.credentialFromResult(result)
          const idToken = credential!.idToken

          api.setToken(idToken)
          userStore.save(result.user, idToken, 'RPPS')
        })
        .catch((error) => {
          userStore.isLoginProgress = false
          pscCibaCode.value = ''
          toast.warning(
            "Merci de saisir à nouveau votre identifiant PSC ou de choisir une autre méthode d'authentification.",
          )
        })
    })
    .catch((error: any) => {
      if (error.data.errorCode === 'auth.proSanteConnect.pendingRequest') {
        window.setTimeout(getToken, 5100)
      } else if (error.data.errorCode === 'auth.proSanteConnect.badRequest') {
        pscCibaCode.value = ''
        userStore.isLoginProgress = false
        toast.warning("Merci de saisir à nouveau votre identifiant PSC ou de choisir une autre méthode d'authentification.")
      }
    })
}

const validate = async () => {
  const { valid, errors } = await loginForm.value?.validate()
  if (valid) {
    emailLoginInProgress.value = true
    if (isEmailAuthent.value) doLoginEmailPassword()
    else if (isPhone(emailOrRpps.value) && systemSettings.value?.data?.is_mobile_login) doLoginPhone()
    else doLoginPscCiba()
  }
}
const validateOTP = async () => {
  const { valid, errors } = await otpForm.value?.validate()
  if (valid && !otpError.value) {
    otpVerificationInProgress.value = true
    if (isEmailAuthent.value) {
      const otpResult = await multiFactorWithSMS(otp.value)
      console.log('otpResult', otpResult)
      otpInError.value = !otpResult
    } else await sendSMSCodeTo()

    otpVerificationInProgress.value = false
  }
}

// Watch for changes in rememberedUsersArray to auto-select single email user
watch(
  rememberedUsersArray,
  (newArray) => {
    if (newArray.length === 1 && newArray[0].type === 'email' && !selectedRememberedUser.value) {
      const user = newArray[0]
      selectedRememberedUser.value = user
      emailOrRpps.value = user.email
      checkIfEmailOrMobile(user.email)
    } else if (newArray.length !== 1 || newArray[0]?.type !== 'email') {
      // Reset selection if conditions are no longer met
      selectedRememberedUser.value = null
      emailOrRpps.value = ''
      isEmailAuthent.value = false
    }

    // If there are multiple remembered users but none selected, or no remembered users and no selection, show PSC
    if ((newArray.length > 1 && !selectedRememberedUser.value) || (newArray.length === 0 && !selectedRememberedUser.value)) {
      emit('on:show-psc', true)
    }
  },
  { deep: true },
)

// Watch for changes in selectedRememberedUser to handle PSC emission
watch(selectedRememberedUser, (newSelectedUser) => {
  if (!newSelectedUser && (rememberedUsersArray.value.length > 1 || rememberedUsersArray.value.length === 0)) {
    // If no user is selected and there are multiple users or no users, show PSC
    emit('on:show-psc', true)
  } else if (newSelectedUser) {
    // If a user is selected, don't show PSC
    emit('on:show-psc', false)
  }
})

onMounted(async () => {
  localStorage.setItem('rememberMe', 'true')
  systemSettings.value = await api.cms.getConfig()
  const rememberedUsers = JSON.parse(localStorage.getItem('rememberUser') || '[]')
  isRememberMeAvailable.value = rememberedUsers.length > 0
  scrollPadding.value = rememberedUsers.length > 3 ? 8 : 0
  rememberedUsers.forEach((user) => {
    rememberedUsersArray.value.push({
      email: user.email,
      name: user.name,
      type: user.type,
      id: user.id,
      initials: getInitials(user.name),
    })
  })

  // Auto-select user and show password input if there's exactly one remembered user and it's an email type
  if (rememberedUsers.length === 1 && rememberedUsers[0].type === 'email') {
    const user = rememberedUsers[0]
    selectedRememberedUser.value = {
      email: user.email,
      name: user.name,
      type: user.type,
      id: user.id,
      initials: getInitials(user.name),
    }
    emailOrRpps.value = user.email
    checkIfEmailOrMobile(user.email)
  } else if (rememberedUsers.length > 0) {
    // If there are remembered users but none selected, show PSC
    emit('on:show-psc', true)
  } else {
    // If no remembered users and no selection, show PSC
    emit('on:show-psc', true)
  }

  await nextTick()
  if (!errorOnLogin.value) await applyRecaptcha()
})
</script>

<style lang="stylus" scoped>
.login-email-password
  align-items flex-start
  display flex
  flex-direction column
  flex 1
  gap 80px
  &--error
    display flex
    flex-direction column
    width 100%
    height 100%
    gap 32px
  .info
    color: var(--Text-6, #3B3B3B)
    body-b4-medium()
    &--contact
      margin-top 8px
      color: var(--Text-6, #3B3B3B)
      body-b5-semibold()
  &--remember-modify-password
    display flex
    justify-content space-between
    .checkbox-with-info-icon
      display flex
      align-items center
      gap 4px
      cursor pointer
      .icon-container
        display: flex;
        width: 14px;
        height: 14px;
        justify-content: center;
        align-items: center;
        border-radius: 2px;
        background: var(--Text-1, #E3E3E3);
        .v-icon
          width 12px
          height 12px

    :deep().v-checkbox
      .v-selection-control
        align-items: center;
        justify-content: center;
        display: flex;
        gap 4px
        min-height: auto;
        &__wrapper
          height: 18px;
          width: 18px;
        .v-icon
          font-size: 16px;
          color var(--Text-6, #3B3B3B)
  &--input-container
    position relative
    &[data-type='password']
      :deep().v-field
        input
          padding-right 80px
    :deep().v-input
      &__details
        color var(--Primary-Warning, #FF4D6A)
        padding-left 0
        body-b3-regular()
    :deep().v-field
      border-radius 4px
      background var(--Textfield-Input-BG-Dark, rgba(0, 0, 0, 0.08)) !important
      border-left 4px solid transparent
      &__outline
        display none
      &--error
        border-left 4px solid var(--Primary-Warning, #FF4D6A)
      .v-label.v-field-label
        margin-left 8px
        padding-right 25px
        color var(--Text-4, #747474)
        body-b3-medium()
      input
        padding-left 8px
        padding-right 50px
        color var(--Text-8, #1F1F1F)
        body-b3-medium()
        &[type="password"]
          font-family caption
          font-size: 20px;
    &__password-icon
      position absolute
      cursor pointer
      top: 10px;
      right: 42px;
      height: 20px;
      display: flex
      align-items: center;
      justify-content: center;
      .v-icon
        height 20px
        width 20px
        font-size: 20px;
        color var(--Text-4, #747474)
    &__icon
      position absolute
      top: 10px;
      right: 8px;
      height: 20px;
      padding-left: 5px;
      border-left 1px solid var(--Text-3, #A4A4A4)
      display: flex
      align-items: center
      justify-content: center
      .v-icon
        height 20px
        width 20px
        font-size: 20px;
        color var(--Text-4, #747474)

  &--button
    display: flex;
    height: 40px;
    padding: 0px 24px;
    justify-content: center;
    align-items: center;
    align-self: stretch;
    width: 100%;
    border-radius: 4px;
    background: var(--Primary-Brand-Lime, #97FF8C);
    &:hover
      background: linear-gradient(to bottom, #97FF8C 0%, #6EE7B7 100%);
    &__label
      color: var(--Text-8, #1F1F1F)
      body-b3-semibold()
      opacity 1
    :deep().v-btn
      &__content
        gap: 8px;
  &--password-reset
    color var(--Text-6, #3B3B3B)
    padding 0
    height auto
    &__label
      color: var(--Text-6, #3B3B3B)
      body-b4-medium()
      cursor pointer
      opacity 1
      text-transform none
  &--goback-btn
    color var(--Text-6, #3B3B3B)
    padding 0
    height auto
    &__label
      color: var(--Text-6, #3B3B3B)
      body-b4-medium()
      cursor pointer
      opacity 1
      text-transform none
      text-decoration-line: underline;
      text-decoration-style: solid;
      text-decoration-skip-ink: auto;
      text-decoration-thickness: auto;
  &--heading
    color: var(--Text-8, #1F1F1F)
    title-t3-uppercase()
    opacity 1
  .psc-ciba-code
    display: flex
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    .heading
      color: var(--Text-3, #A4A4A4);
      body-b5-regular()
      margin-bottom: 16px;
    .code
      display: flex;
      padding: 16px;
      justify-content: center;
      align-items: center;
      gap: 8px;
      border-radius: 8px;
      background: var(--Interface-Pearl, #EDEDED);
      color: #000;
      leading-trim: both;
      text-edge: cap;
      font-family: Roboto;
      font-size: 64px;
      font-style: normal;
      font-weight: 600;
      line-height: 100%; /* 64px */
      text-transform: uppercase;
  .v-form
    display flex
    width: 100%;
    gap 32px
    flex-direction column
    .input-container
      display flex
      flex-direction column
      gap 10px
    .login-otp
      &--input-container
        &__error-message
          color var(--Primary-Warning, #FF4D6A)
          body-b5-regular()
        :deep().v-otp-input
          padding-top 0
          &__content
            height: 56px;
            padding: 0.5rem 0;
        :deep().v-field
          border-radius 4px
          background var(--Textfield-Input-BG-Dark, rgba(0, 0, 0, 0.08)) !important
          &__outline
            display none
          input
            color var(--Text-8, #1F1F1F)
            otp-n3-bold()
        .otp-message
          white-space inherit
  h3
    margin-top 20px

.user-list
  display flex
  flex-direction column
  width 100%
  max-height 152px
  opacity 1
  gap 16px
  box-sizing border-box
  overflow-y auto
  margin-bottom 20px
  &::-webkit-scrollbar
    width 4px
  &::-webkit-scrollbar-track
    background #f1f1f1
  &::-webkit-scrollbar-thumb
    background #C9C9C9
    border-radius 2px
  &::-webkit-scrollbar-thumb:hover
    background #C9C9C9

  .user-item
    display flex
    height 40px
    background-color #00000014
    padding 2px 8px 2px 2px
    align-items center
    gap 16px
    align-self stretch
    cursor pointer
    border-radius 4px

    .avatar
      display flex
      width 36px
      height 36px
      background-color #F6F6F6
      justify-content center
      align-items center
      aspect-ratio 1/1
      border-radius 2px

    .initials
      color #3B3B3B
      text-align right
      font-size 18px
      font-style normal
      font-weight 600
      line-height 100%
      text-transform uppercase
    .text-block
      flex 1
      min-width 0
      text-align left
      overflow hidden
      .name
        font-size 11px
        font-style normal
        font-weight 500
        line-height normal
        color #3B3B3B

      .email
        font-size 10px
        font-style normal
        font-weight 400
        line-height normal
        color #3B3B3B
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    .append-icons
      display flex
      gap 8px
      align-items center
      button
        height 24px
        width 24px
.custom-tooltip :deep().v-overlay
  &__content
    body-b4-regular()
    border-radius 4px
    background var(--Text-8, #1F1F1F)
    color var(--Text-0, #FFF)
    font-size 14px
    border-radius 6px
    padding 8px 16px
    box-shadow 0 2px 8px rgba(0,0,0,0.15)

.append-icons-menu :deep().v-overlay
  &__content
    .v-list
      padding: 8px;
      border-radius: 4px;
      background: var(--Interface-Dark-3-3, #CECECE);
      .v-list-item
        display: flex
        padding: 8px;
        justify-content: center;
        align-items: center;
        min-height: 12px;
        padding: 0;
        margin: 0;
        &__content
          display: flex;
        .v-icon
          width: 12px;
          height: 12px;
        .v-list-item-title
          body-b4-regular()
          color: var(--Text-8, #1F1F1F);
          leading-trim: both;
          text-edge: cap;
</style>
